<script lang="ts">
	import type { ChangeEventHandler } from 'svelte/elements';
	import GlobalMedia from '../media/GlobalMedia.svelte';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	export let max = 10;
	export let min = 1;
	export let value: number;
	export let stepSize = 1;

	export let variant: 'normal' | 'small' = 'normal';

	function clamp(value: number) {
		return Math.min(max, Math.max(min, value));
	}

	function increment() {
		value = clamp(value + stepSize);
		dispatchChangeEvent();
	}

	function decrement() {
		value = clamp(value - stepSize);
		dispatchChangeEvent();
	}

	let inputValue = value;
	$: inputValue = value;

	function dispatchChangeEvent() {
		dispatch('change', value);
	}

	function handleInput(val: string | undefined) {
		if (!val) return;
		const numVal = Number(val.trim());

		if (!isNaN(numVal)) {
			value = clamp(numVal);
		}
		inputValue = value; // we need to manuelly set it because if the value does not change but the input value changed it did not reassing the inputvalue to the clamped value
		dispatchChangeEvent();
	}
</script>

<div class="quantitiy-selector variant-{variant}">
	<button on:click={decrement} disabled={value <= min} class="button decrement-button">
		<GlobalMedia key="icon-minus" />
	</button>
	<input
		bind:value={inputValue}
		on:change={(e) => handleInput(e?.target?.value)}
		class="textfield"
	/>
	<button on:click={increment} disabled={value >= max} class="button increment-button">
		<GlobalMedia key="icon-plus" />
	</button>
</div>

<style lang="scss">
	.quantitiy-selector {
		display: flex;
		height: v(input__height);
		width: 9rem;
		background-color: color(white);
		border: 4px solid color(white);
		border-radius: v(input__border-radius);
		overflow: hidden;
	}

	.variant-small {
		height: 26px;
		border-radius: v(input__border-radius__small);
		border: 1px solid color(white);
		width: 5rem;
		@include font(text-sm);

		.button {
			padding: 0;
			font-size: 0.9rem;

			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
		}

		.textfield {
			@include font(text-sm);
			padding-top: 0.2em;
		}
	}

	.button,
	.textfield {
		border: none;
		appearance: none;
		background: none;
	}

	.button {
		height: 100%;
		aspect-ratio: 1;
		cursor: pointer;
		background-color: color(grey-lighter);
		border-radius: v(input__border-radius);
		@include transition(all);
		position: relative;
		font-size: 1rem;
		width: 50%;
		display: flex;
		align-items: center;

		padding-inline: v(content-padding-sm);

		:global(.svg) {
			height: 0.75em;
			width: 0.75em;
			@include transition(all);
		}

		&:hover {
			background-color: color(light-grey);
		}

		&:disabled {
			cursor: not-allowed;
			:global(svg) {
				opacity: 0.3;
			}
		}
	}

	.textfield {
		height: 100%;
		width: 100%;
		text-align: center;
		@include font(text-lg);
	}

	div {
		display: flex;
		align-items: center;
	}

	button {
		padding: 0.5rem;
		font-size: 1rem;
	}

	span {
		margin: 0 1rem;
		font-size: 1rem;
	}
</style>
